enum COLORS {
    PRIMARY = 'primary-text-lg-aa',
    SECONDARY = 'secondary-text-lg-aa',
    BLUE = 'blue-500',
    INDIGO = 'indigo-600',
}

export default COLORS;

// All color classes
{
    <>
        <noscript className="border-primary-text-lg-aa bg-primary-text-lg-aa text-primary-text-lg-aa ring-primary-text-lg-aa hover:bg-primary-text-lg-aa focus:ring-primary-text-lg-aa" />
        <noscript className="border-secondary-text-lg-aa bg-secondary-text-lg-aa text-secondary-text-lg-aa ring-secondary-text-lg-aa hover:bg-secondary-text-lg-aa focus:ring-secondary-text-lg-aa" />
        <noscript className="border-blue-500 bg-blue-500 text-blue-500 ring-blue-500 hover:bg-blue-500 focus:ring-blue-500" />
        <noscript className="border-indigo-600 bg-indigo-600 text-indigo-600 ring-indigo-600 hover:bg-indigo-600 focus:ring-indigo-600" />
    </>;
}
